<!-- Check dependencies container-->
<ng-container *ngIf="isStepByStep && !showingDependencies && !hasNotDependencies">
  <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
    <div>{{ getMainTitle() }}</div>
    <button type="button" mat-icon-button (click)="close()" tabindex="-1">
      <mat-icon [icIcon]="icClose"></mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <p>{{ getCheckMessage() }}</p>
    <p>Souhaitez-vous lancer cette vérification ?</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Annuler</button>
    <button mat-button color="primary" [loading]="loading" (click)="checkDependencies()">Vérifier</button>
  </mat-dialog-actions>
</ng-container>

<!-- List of dependencies container-->

<ng-container
  *ngIf="showingDependencies && !hasNotDependencies && (!this.canChangeDependencies || this.canArchiveWithDependencies)"
>
  <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
    <ng-container *ngIf="!this.canArchiveWithDependencies">
      <div>{{ getImpossibleTitle() }}</div>
    </ng-container>
    <ng-container *ngIf="this.canArchiveWithDependencies">
      <div>{{ getAutoDependenciesTitle() }}</div>
    </ng-container>
    <button type="button" mat-icon-button (click)="close()" tabindex="-1">
      <mat-icon [icIcon]="icClose"></mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <!-- Explications contextuelles pour la mise hors service d'équipement -->
    <ng-container *ngIf="actionType === 'end-service' && serviceToUse?.entityApi === 'equipment'">
      <div class="bg-amber-50 border-l-4 border-amber-400 p-4 mb-4">
        <p class="text-sm text-amber-800 font-medium mb-2">Impact de la mise hors service :</p>
        <ul class="text-sm text-amber-700 list-disc pl-5 space-y-1">
          <li *ngIf="hasDependencyType('Tickets')">
            <strong>Tickets :</strong>
            Les articles et prestations contenus dans les paniers ci-dessous seront définitivement retirés.
          </li>
          <li *ngIf="hasDependencyType('Contrats')">
            <strong>Contrats :</strong>
            L'équipement sera retiré du périmètre des contrats listés ci-dessous.
          </li>
        </ul>
      </div>
    </ng-container>

    <!-- Explications contextuelles pour la mise hors service de bâtiment -->
    <ng-container *ngIf="actionType === 'end-service' && serviceToUse?.entityApi === 'building'">
      <div class="bg-amber-50 border-l-4 border-amber-400 p-4 mb-4">
        <p class="text-sm text-amber-800 font-medium mb-2">Impact de la mise hors service :</p>
        <ul class="text-sm text-amber-700 list-disc pl-5 space-y-1">
          <li *ngIf="hasDependencyType('Equipements')">
            <strong>Équipements :</strong>
            Les équipements associés seront automatiquement mis hors service.
          </li>
          <li *ngIf="hasDependencyType('Paniers')">
            <strong>Paniers eShop :</strong>
            Les articles et prestations contenus dans les paniers ci-dessous seront définitivement retirés.
          </li>
          <li *ngIf="hasDependencyType('Contrats')">
            <strong>Contrats :</strong>
            Le bâtiment sera retiré du périmètre des contrats listés ci-dessous.
          </li>
          <li *ngIf="mainEstablishments && mainEstablishments.length > 0">
            <strong>Établissements :</strong>
            Ce bâtiment est le bâtiment principal de certains établissements. Vous devez assigner un nouveau bâtiment
            principal avant de continuer.
          </li>
        </ul>
      </div>
    </ng-container>

    <ng-container *ngIf="serviceToUse?.entityApi === 'building' && mainEstablishments.length > 0">
      <section class="card p-5 mb-4">
        <ng-container *ngIf="groupedDependencies.length > 0; else simpleList1">
          <div *ngFor="let group of groupedDependencies">
            <p class="font-bold text-lg text-primary mt-4 mb-2 ml-2">{{ group.tenant }}</p>
            <div *ngFor="let cat of group.categories">
              <p *ngIf="cat.dependencies.length > 0" class="font-semibold text-gray-700 mt-2">
                {{ cat.name }}
                <span class="item-badge" fxFlex="none">{{ cat.dependencies.length }}</span>
              </p>
              <p>{{ cat.dependencies }}</p>
            </div>
          </div>
        </ng-container>
        <ng-template #simpleList1>
          <div *ngFor="let data of dependencies.data">
            <p *ngIf="data.dependencies.length > 0" class="font-semibold text-lg text-gray-700 mt-4 mb-2">
              {{ data.name }}
              <span class="item-badge" fxFlex="none">{{ data.dependencies.length }}</span>
            </p>

            <p>{{ data.dependencies }}</p>
          </div>
        </ng-template>
      </section>
      <p>Veuillez assigner un autre bâtiment principal à ces établissements ou les archiver pour continuer.</p>
      <p>Ce bâtiment est le bâtiment principal des établissements suivants :</p>
      <div *ngFor="let est of mainEstablishments" class="mb-4">
        <p class="font-semibold mb-2">{{ est.label }}</p>
        <ng-container *ngIf="est.buildings.length > 0; else noAlt">
          <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
            <mat-form-field appearance="fill" fxFlex>
              <mat-label>Choisir un autre bâtiment principal</mat-label>
              <mat-select [(ngModel)]="est.selectedBuildingId">
                <mat-option *ngFor="let b of est.buildings" [value]="b._id">{{ b.label }}</mat-option>
              </mat-select>
            </mat-form-field>
            <button mat-button color="primary" (click)="assignMainBuilding(est)" [disabled]="!est.selectedBuildingId">
              Assigner
            </button>
          </div>
        </ng-container>
        <ng-template #noAlt>
          <p>
            Aucun autre bâtiment n'est associé à cet établissement. Ajoutez-en un pour pouvoir réassigner le bâtiment
            principal.
          </p>
        </ng-template>
      </div>
    </ng-container>

    <section class="card p-5 mb-4" *ngIf="!(serviceToUse?.entityApi === 'building' && mainEstablishments.length > 0)">
      <ng-container *ngIf="groupedDependencies.length > 0; else simpleListNoBuilding">
        <div *ngFor="let group of groupedDependencies">
          <p class="font-bold text-lg text-primary mt-4 mb-2 ml-2">{{ group.tenant }}</p>
          <div *ngFor="let cat of group.categories">
            <p *ngIf="cat.dependencies.length > 0" class="font-semibold text-gray-700 mt-2">
              {{ cat.name }}
              <span class="item-badge" fxFlex="none">{{ cat.dependencies.length }}</span>
            </p>
            <p>{{ cat.dependencies }}</p>
          </div>
        </div>
      </ng-container>
      <ng-template #simpleListNoBuilding>
        <div *ngFor="let data of dependencies.data">
          <p *ngIf="data.dependencies.length > 0" class="font-semibold text-lg text-gray-700 mt-4 mb-2">
            {{ data.name }}
            <span class="item-badge" fxFlex="none">{{ data.dependencies.length }}</span>
          </p>

          <p>{{ data.dependencies }}</p>
        </div>
      </ng-template>
    </section>
  </mat-dialog-content>

  <!-- Si des mainEstablishments existent pour un bâtiment, bloquer complètement -->
  <ng-container
    *ngIf="
      !this.canChangeDependencies &&
        this.canArchiveWithDependencies &&
        !(serviceToUse?.entityApi === 'building' && mainEstablishments.length > 0);
      else closeOnly
    "
  >
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="close()">Annuler</button>
      <button mat-button color="primary" [loading]="loading" (click)="changeAutoDependenciesAndArchive()">
        {{ getButtonText() }}
      </button>
    </mat-dialog-actions>
  </ng-container>

  <ng-template #closeOnly>
    <mat-dialog-actions align="end">
      <button mat-button (click)="close()">Fermer</button>
    </mat-dialog-actions>
  </ng-template>
</ng-container>

<!-- can change dependencies container-->

<ng-container *ngIf="showingDependencies && !hasNotDependencies && this.canChangeDependencies">
  <form [formGroup]="form">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
      <div>{{ getChangeRequiredMessage() }}</div>
      <button type="button" mat-icon-button (click)="close()" tabindex="-1">
        <mat-icon [icIcon]="icClose"></mat-icon>
      </button>
    </div>

    <mat-dialog-content fxLayout="column" fxLayoutGap="16px">
      <section class="card p-5 mb-4">
        <ng-container *ngIf="groupedDependencies.length > 0; else simpleList2">
          <div *ngFor="let group of groupedDependencies">
            <p class="font-bold text-lg text-primary mt-4 mb-2 ml-2">
              {{ group.tenant }}
            </p>
            <div *ngFor="let cat of group.categories">
              <p *ngIf="cat.dependencies.length > 0" class="font-semibold text-gray-700 mt-2">
                {{ cat.name }}
                <span class="item-badge" fxFlex="none">
                  {{ cat.dependencies.length }}
                </span>
              </p>
              <ul class="list-disc pl-4 max-h-40 overflow-y-auto">
                <li *ngFor="let dep of cat.dependencies">{{ dep }}</li>
              </ul>
            </div>
          </div>
        </ng-container>
        <ng-template #simpleList2>
          <div *ngFor="let data of dependencies.data">
            <p *ngIf="data.dependencies.length > 0" class="font-semibold text-lg text-gray-700 mt-4 mb-2">
              {{ data.name }}
              <span class="item-badge" fxFlex="none">
                {{ data.dependencies.length }}
              </span>
            </p>

            <ul class="list-disc pl-4 max-h-40 overflow-y-auto">
              <li *ngFor="let dep of data.dependencies">{{ dep }}</li>
            </ul>
          </div>
        </ng-template>
      </section>

      <ng-container *ngIf="fieldConfig as cfg">
        <ng-container *ngIf="items$ | async as items">
          <base-form-input
            [label]="cfg.label"
            type="autocomplete"
            [items$]="items$"
            (autocompleteChange)="itemsAutoCompleteChange($event)"
            displayProperty="label"
            [controlName]="cfg.controlName"
            [disabled]="items.length === 0"
          ></base-form-input>

          <p *ngIf="items.length === 0" class="text-caption">
            {{ noItemsMessage }}
          </p>
        </ng-container>
      </ng-container>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="close()">Annuler</button>
      <button
        mat-button
        color="primary"
        [loading]="loading"
        [disabled]="form.invalid || form.get(fieldConfig.controlName)?.disabled"
        (click)="changeAndArchiveGeneric()"
      >
        {{ getModifyAndActionButton() }}
      </button>
    </mat-dialog-actions>
  </form>
</ng-container>

<ng-container *ngIf="isStepByStep && hasNotDependencies">
  <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
    <div>{{ getConfirmTitle() }}</div>
    <button type="button" mat-icon-button (click)="close()" tabindex="-1">
      <mat-icon [icIcon]="icClose"></mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <p>{{ getConfirmMessage() }}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Annuler</button>
    <button mat-button color="primary" [loading]="loading" (click)="executePrimaryAction()">
      {{ getPrimaryActionLabel() }}
    </button>
  </mat-dialog-actions>
</ng-container>
